/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/WalletEvent.php */
export const walletEvent = {
	Credited: 'credited',
	Debited: 'debited',
	Held: 'held',
	Settled: 'settled',
	Released: 'released',
} as const

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/WalletEvent.php */
export type WalletEvent = (typeof walletEvent)[keyof typeof walletEvent]
